import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import EcoButton from 'eco-design/base/eco-button';
import React, { useState } from 'react';
import styles from './index.module.scss';
import ModalWrap from './components/modal';
import { useLang } from '@/i18n';
import useCardsShowHook from '../useHooks/useCardsShowHook';
import gtm from '@/utils/gtm';
import { AddIcon, DownIcon } from '../icons';

const KSPPicture: React.FC = () => {
    const { t } = useLang('Delta3AirStation');
    const [open, setOpen] = useState<boolean>(false);

    const getModalContent = () => {
        const list = [
            {
                title: t('KSPPicture.modal_title_1'),
                desc: t('KSPPicture.modal_desc_1'),
                imgPc: 'https://websiteoss.ecoflow.com/upload/image/1761815423285/ksp-sub-3-pc.jpg',
            },
            {
                title: t('KSPPicture.modal_title_2'),
                desc: t('modal_desc_2'),
                imgPc: 'https://websiteoss.ecoflow.com/upload/image/1761815423051/ksp-sub-1-pc.jpg',
            },
            {
                title: t('KSPPicture.modal_title_3'),
                desc: t('KSPPicture.modal_desc_3'),
                imgPc: 'https://websiteoss.ecoflow.com/upload/image/1761815423761/ksp-sub-2-pc.jpg',
            },
        ];
        return list;
    };

    const handlePush = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_details',
            tab: '耐震・耐熱・耐湿の堅牢設計',
            button_name: '+',
        });
    };

    const handlePushAnchor = (title: string, name: string, id1: string, id2: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_anchor',
            position: title,
            button_name: name,
            __btn_id1: id1,
            __btn_id2: id2,
            __btn_type: 'href',
        });
    };

    const handleOpen = (e: any) => {
        e.stopPropagation();
        e.preventDefault();
        setOpen(true);
        handlePush();
    };

    useCardsShowHook('.rights-content .item', '.rights-content');

    return (
        <section className={`${styles.KSPPicture} GtmModuleData-section`} data-section-id="KSPPicture">
            <div className="rights-content">
                <EcoLink
                    className="item item1 GtmModuleData-btn-href"
                    href="#List-sence-C"
                    onClick={() => handlePushAnchor(t('FullPowerTrigger.title'), '4つの充電方式', 'item1', '#List-sence-C')}
                >
                    <div className="sub-text">
                        <div className="item-title">4つの充電方式</div>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1762161889948/PC.png"
                        pad="https://websiteoss.ecoflow.com/upload/image/1762161889948/PC.png"
                        h5="https://websiteoss.ecoflow.com/upload/image/1762161889750/MOB.png"
                        isOpenLazy
                    ></EcoImg>
                    <span className="add-icon">
                        <DownIcon />
                    </span>
                </EcoLink>

                <EcoLink
                    className="item item2 GtmModuleData-btn-href"
                    href="#List-sence-A"
                    onClick={() => handlePushAnchor(t('LightestUsedSence.title'), '1,000Whクラス世界最小・最軽量', 'item2', '#List-sence-A')}
                >
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1762333438367/Frame%201612707998.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1762333438367/Frame%201612707998.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1762333438083/Frame%201612707427.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <div className="sub-text"></div>
                    <span className="add-icon">
                        <DownIcon />
                    </span>
                </EcoLink>

                <EcoLink
                    className="item item3 GtmModuleData-btn-href"
                    href="#List-sence-D"
                    onClick={() => handlePushAnchor(t('SenceCardB.title'), '片手で持ち運び', 'item3', '#List-sence-D')}
                >
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1761807804441/ksp-3.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1761807804441/ksp-3.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1761824309826/ksp-2-m.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <div className="sub-text">
                        <div className="item-title">片手で持ち運び</div>
                    </div>
                    <span className="add-icon">
                        <DownIcon />
                    </span>
                </EcoLink>

                <EcoLink
                    className="item item4 GtmModuleData-btn-href"
                    href="#List-sence-D"
                    onClick={() => handlePushAnchor(t('SenceCardB.title'), '横置きOK使い方も収納ももっと便利に', 'item4', '#List-sence-D')}
                >
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1761807805461/ksp-4.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1761807805461/ksp-4.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1761824312058/ksp-4-m.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <div className="sub-text">
                        <div className="item-title">横置きOK</div>
                        <div className="item-desc">使い方も収納ももっと便利に</div>
                    </div>
                    <span className="add-icon">
                        <DownIcon />
                    </span>
                </EcoLink>

                <EcoLink
                    className="item item5 GtmModuleData-btn-href"
                    href="#List-sence-E"
                    onClick={() => handlePushAnchor(t('SenceCardC.title'), '定格500W（X-Boost時 800W対応）', 'item5', '#List-sence-E')}
                >
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1761807805288/ksp-5.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1761807805288/ksp-5.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1761824310127/ksp-5-m.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <div className="sub-text">
                        <div className="item-title">
                            <span>定格</span>
                            <span className="special">500W</span>
                        </div>
                        <div className="item-desc">（X-Boost時 800W対応）</div>
                    </div>
                    <span className="add-icon">
                        <DownIcon />
                    </span>
                </EcoLink>

                <EcoLink
                    className="item item6 GtmModuleData-btn-href"
                    href="#List-sence-G"
                    onClick={() => handlePushAnchor(t('SenceCardE.title'), 'もしもの時に&lt;20ms自動切り替え', 'item6', '#List-sence-G')}
                >
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1761807805100/ksp-6.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1761807805100/ksp-6.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1761807805100/ksp-6.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <div className="sub-text">
                        <div className="item-title">
                            <span className="item6-title">もしもの時に</span>
                            <span className="special">&lt;20ms</span>
                        </div>
                        <div className="item-desc">自動切り替え</div>
                    </div>
                    <span className="add-icon">
                        <DownIcon />
                    </span>
                </EcoLink>
                <EcoLink
                    className="item item7 GtmModuleData-btn-href"
                    href="#List-sence-B"
                    onClick={() => handlePushAnchor(t('SecurityProtection.title'), '耐震・耐熱・耐湿の堅牢設計', 'item7', '#List-sence-B')}
                >
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1761807804738/ksp-7.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1761824310330/ksp-3-m.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1761824310330/ksp-3-m.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <div className="sub-text">
                        <div className="item-title">耐震・耐熱・耐湿</div>
                        <div className="item-desc">の堅牢設計</div>
                        {/* <EcoButton lType="outlined" className="modal-btn" onClick={(e) => handleOpen(e)}>
                            タフ設計の裏側へ
                        </EcoButton> */}
                    </div>
                    <span className="add-icon">
                        <DownIcon />
                    </span>
                </EcoLink>

                <EcoLink
                    className="item item8 GtmModuleData-btn-href"
                    href="#List-sence-F"
                    onClick={() => handlePushAnchor(t('SenceCardD.title'), '残量や充電状況をいつでもチェック', 'item8', '#List-sence-F')}
                >
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1761807805657/ksp-8.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1761807805657/ksp-8.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1761824312510/ksp-6-m.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <div className="sub-text">
                        <div className="item-title">
                            残量や充電状況を
                            <br />
                            いつでもチェック
                        </div>
                        <div className="item-desc"></div>
                    </div>
                    <span className="add-icon">
                        <DownIcon />
                    </span>
                </EcoLink>
            </div>
            <div>
                <ModalWrap open={open} setOpen={setOpen}>
                    <div className="content-wrap">
                        {getModalContent().map((item: any, index: number) => (
                            <div className="show-item-1" key={index}>
                                <div className="sub-title">{item.title}</div>
                                <div className="sub-desc">{item.desc}</div>
                                <div className="sub-img">
                                    <EcoImg pc={item.imgPc} pad={item.imgPc} isOpenLazy></EcoImg>
                                </div>
                            </div>
                        ))}
                    </div>
                </ModalWrap>
            </div>
        </section>
    );
};

export default KSPPicture;
